module.exports = __webpack_public_path__ + "static/ipad@2x-92b1baa41fcf9e3770f1791a107b505c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pop/devices/ipad@2x.png
// module id = 920
// module chunks = 115276404313086 271422636699454